module.exports = __webpack_public_path__ + "img/8Y.b8590fd9.png";